import changerListViewComponent from './changer-list-view.component';

const changerListViewModule = angular
  .module('changerListViewModule', [])
  .component('changerListView', changerListViewComponent);

export default changerListViewModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/active/changer-list-view/changer-list-view.js
 **/